import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { map } from 'lodash';
import './Choice.scss';

const Choice = (props) => {
  const { name, label, choices } = props;
  return (<div>
    <Field
      name={name}
      component={(lights) => {
        const hasError = lights.meta.touched && lights.meta.error;
        return (
          <div>
            <div className="contact-us-normal-text">{label}</div>
            <ul className={`${hasError ? 'choice-error ' : ''}choice-field`}>
              {map(choices, item => (
                <li key={item.id}>
                  <input
                    className="form-radio-input"
                    id={item.id}
                    type="radio" {...lights.input}
                    value={item.value}
                    checked={lights.input.value === item.value}
                  />
                  <label className="form-radio-label" htmlFor={item.id} id={`autotest-${item.id}`}>
                    {item.value}
                  </label>
                </li>
              ))}
            </ul>
            {hasError &&
            <div className="choice-text-error">{lights.meta.error}</div>
            }
          </div>
        );
      }
      }
    />
  </div>);
};

Choice.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  choices: PropTypes.arrayOf(PropTypes.object)
};

export default Choice;



/** WEBPACK FOOTER **
 ** ./src/components/ContactUs/Choice/Choice.js
 **/